import { Box, Collapse } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';

import CustomButton from 'components/buttons/CustomButton/CustomButton';
import CustomFormTextInput from 'components/inputs/CustomFormTextInput/CustomFormTextInput';

import { ProductsFilterDto } from 'types/dto/ProductsFilterDto';

interface Props {
  open: boolean;
  initialValues: ProductsFilterDto;
  loading: boolean;
  onApply: (filters: ProductsFilterDto) => void;
  onReset: () => void;
}

export default function ProductsFilters({
  open,
  initialValues,
  loading,
  onApply,
  onReset,
}: Props) {
  const methods = useForm<ProductsFilterDto>({
    defaultValues: initialValues,
  });

  const { handleSubmit, reset } = methods;

  return (
    <Collapse in={open} timeout="auto" unmountOnExit>
      <Box
        sx={{
          px: 2,
          py: 2,
          borderBottom: '1px solid',
          borderColor: 'divider',
        }}
      >
        <FormProvider {...methods}>
          <Box
            component="form"
            onSubmit={handleSubmit(onApply)}
            display="grid"
            gridTemplateColumns={{ xs: '1fr', md: 'repeat(4, 1fr)' }}
            gap={2}
            flex={1}
          >
            {/* Name */}
            <CustomFormTextInput
              name="name"
              floatingLabel='Name'
              register={methods.register}
            />

            {/* Barcode */}
            <CustomFormTextInput
              name="barcode"
              floatingLabel='Barcode'
              register={methods.register}
            />

            {/* Actions */}
            <Box
              display="flex"
              gap={1}
              alignItems="flex-end"
              justifyContent="flex-end"
              sx={{
                alignSelf: 'end',
              }}
            >
              <CustomButton
                fullWidth
                text="Reset"
                variant="outlined"
                height={40}
                disabled={loading}
                onClick={() => {
                  reset();
                  onReset();
                }}
              />
              <CustomButton
                fullWidth
                text="Search"
                type="submit"
                height={40}
                loading={loading}
              />
            </Box>
          </Box>
        </FormProvider>
      </Box>
    </Collapse>
  );
}
